<div class="messages-container " [ngClass]="{
  'hide-messages': hideMessageArea == false,
  'messages-container-with-modal-open': isModalOpen == true
}">
    <div class="messages-header">
      <div class="header-right">
        <button (click)="hideAreaMessage()" mat-icon-button id="btnNotifications">
          <mat-icon>arrow_drop_down</mat-icon>
        </button>
      </div>
      <div class="header-left">
        <span>{{ 'notifications'|translate}}</span>
        <span *ngIf="hubConnected == true" class="hub-connection-status on-connected">{{'hubStatusConnected'|translate}}</span>
        <span *ngIf="hubConnected == false && hubConnecting == true" class="hub-connection-status on-connecting">{{'hubStatusOnConnectingMin'|translate}}</span>
        <span  *ngIf="hubConnected == false  && hubConnecting == false" class="hub-connection-status on-close">{{'hubStatusConnectedMin'|translate}}</span>
        <span class="notificationIcon" *ngIf="this.newNotifications == true" ></span>
      </div>
    </div>
    <div class="messages-area">
      <div *ngFor="let notification of notifications" class="message">
        <div class="message-content-left">
          <img class="message-icon" [src]="notification.IconUrl" alt="{{ notification.EventType}}">
        </div>
        <div class="message-content-right">
          <div class="message-content-row">
            <div> 
              <span class="message-key-name">{{ 'eventtype' | translate}}: </span>
              {{notification.EventType}}
            </div>
          </div>
          <div class="message-content-row">
            <div>
              <span class="message-key-name">{{ 'date' | translate}}:</span>
              {{notification.EventDate}}
            </div>
          </div>
          <div class="message-content-row">
            <div>
              <span class="message-key-name">{{ 'site'|translate}}:</span> 
              {{notification.SiteName}}
            </div>
            <div>
              <span class="message-key-name">{{ 'Location'|translate}}</span> 
              {{notification.LocationName}}
            </div>
          </div>
        </div>
        <div class="message-image">
          <img [src]="notification.ImageUrl" alt="Imagen">
        </div>
        <span class="btnClose" (click)="CloseNotification(notification)">
          <mat-icon>close</mat-icon>
        </span>
      </div>
    </div>
  </div>


  <!-- <div  class="hub-connection-status-box">
    <div *ngIf="hubConnected == false" class="hub-status on-close">
        El servicio de notificaciones no está conectado
    </div>
    <div *ngIf="hubConnected == false && hubConnecting == true" class="hub-status on-connecting">
        Conectando al servicio de notificaciones...
    </div>
    <div *ngIf="hubConnected == true" class="hub-status on-connected">
        Conectado al servicio de notificaciones
    </div> -->
<!-- </div> -->